import React from "react";

export default function About() {
  return (
    <div className="max-w-2xl mx-auto text-center">
      <h2 className="text-3xl font-bold text-primary mb-4">About Me</h2>
      <p className="mb-6">
        Hi, I’m Zhanar Nurbekova! I started SoMa Childcare because I believe children learn best in a warm, home-like setting. 
        I’m licensed, CPR and First Aid certified.
      </p>
      <img
        src="IMG_20220429_000905_600.jpg"
        alt="Owner"
        className="rounded-lg shadow-lg mx-auto w-48"
      />
    </div>
  );
}